import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => {
  return createStyles({
    form: {
      display: 'flex',
      flexDirection: 'column',
    },
    containerInputBetweenTexts: {
      '& .MuiFormControl-root': {
        width: '100%',
        '& .MuiFormHelperText-root': {
          margin: 0,
          overflow: 'visible',
        },
      },
    },
  });
});
